import React from 'react';

import Link from '../../../../../../library/link/link';
import Typography from '../../../../../../library/typography/typography';
import Price from '../../../../../../components/price/price';
import ProductImage from '../../../../../../components/product-image/product-image';
import TopThreeTileHeader from '../top-three-tile-header/top-three-tile-header';

import { PriceInfoProps } from '../../../../../../shared/types/product';
import { PRODUCT_TILE_TYPES } from '../../../../../../shared/constants/treadwell';

import './top-three-tile.scss';

interface TopThreeTileProps {
  brand?: string;
  detailsLink?: string;
  imageUrl?: string;
  name?: string;
  onViewDetailsClick?: (value: string) => void;
  priceInfo?: PriceInfoProps;
  priceSubtext?: string;
  rank?: number;
  rearCode?: string;
  rearPriceInfo?: PriceInfoProps;
  type: typeof PRODUCT_TILE_TYPES[keyof typeof PRODUCT_TILE_TYPES];
  unitName?: string;
}

//TODO: Attempt to use ProductTile to make TopThreeTile and SuggestedSellingTile consistent
function TopThreeTile(props: TopThreeTileProps) {
  const {
    brand,
    detailsLink = '',
    imageUrl,
    name,
    onViewDetailsClick,
    priceInfo,
    priceSubtext,
    rank,
    rearCode,
    rearPriceInfo,
    type,
    unitName
  } = props;

  const isTreadwell = Boolean(rank && rank > 0);
  const { mapPrice, price, priceRange } = priceInfo || {};
  const {
    mapPrice: rearMapPrice,
    price: rearPrice,
    priceRange: rearPriceRange
  } = rearPriceInfo || {};

  return (
    <div styleName={rearCode ? 'staggered-tile' : 'tile'}>
      <div styleName="inner-tile">
        <TopThreeTileHeader isTreadwell={isTreadwell} rank={rank} type={type} />
        <Link
          onClick={() =>
            onViewDetailsClick?.(
              `product_list_attribute_top_3_${type?.toLowerCase()}`
            )
          }
          styleName="container-link"
          to={detailsLink}
        >
          <div styleName="tile-content">
            {imageUrl && !rearCode && (
              <ProductImage
                ariaLabel={name}
                className="top-three-product-image"
                height={92}
                imageFormatType={
                  process.env.__FF_PRODUCT_IMAGE_FORMATS_AUTO_SYNC__ === 'true'
                    ? 'PRODUCT_X_SMALL'
                    : 'LIST'
                }
                imageUrl={imageUrl}
                width={92}
              />
            )}
            <div styleName="text-container">
              <div styleName="brand-name-container">
                <Typography
                  size="extraSmall"
                  styleName="brand"
                  tag="span"
                  weight="black"
                >
                  {brand}
                </Typography>
                <Typography styleName="name" tag="span" weight="black">
                  {name}
                </Typography>
              </div>
              <div styleName="tile-summary">
                <span styleName="price-container">
                  <Typography
                    size="small"
                    styleName={rearCode ? 'staggered-price' : 'price'}
                    tag="span"
                  >
                    {rearCode && <span styleName="price-label">Front:</span>}
                    {price && (
                      <Price
                        className="price"
                        mapPrice={mapPrice}
                        price={price}
                        priceRange={priceRange}
                        unitName={unitName}
                      />
                    )}
                  </Typography>
                  {rearCode && rearPrice && (
                    <Typography
                      size="small"
                      styleName="staggered-price-rear"
                      tag="span"
                    >
                      <span styleName="price-label">Rear:</span>
                      <Price
                        className="price"
                        mapPrice={rearMapPrice}
                        price={rearPrice}
                        priceRange={rearPriceRange}
                        unitName={unitName}
                      />
                    </Typography>
                  )}
                </span>
                {priceSubtext && (
                  <Typography
                    size="extraSmall"
                    styleName="price-subtext"
                    tag="span"
                  >
                    {priceSubtext}
                  </Typography>
                )}

                {detailsLink && (
                  <Typography
                    size="small"
                    styleName="view-details"
                    tag="span"
                    weight="bold"
                  >
                    View Details
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default TopThreeTile;
